import { BaSeIcon, BaSeParagraph, BaSeStepper, BaSeTheme } from '@base/react';
import React from 'react';
import {
  Container,
  ImageResult,
  ImageWrapper,
  ResultBoxMessageWrapper,
  ResultTextMessagetWrapper,
  ResultTextSubTitle,
  ResultTextTitle,
  ResultWrapper,
  StepWrapper,
} from './result-styled';

export const Result = () => {
  const steps = React.useMemo(
    () => [
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: 'Proximidade',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: 'Avaliação',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: 'Adjetivos',
      },
    ],
    [],
  );

  return (
    <React.Fragment>
      <Container>
        <ResultWrapper>
          <StepWrapper>
            <BaSeStepper
              steps={steps}
              onStepChange={() => {}}
              currentStep={3}
              activeWithErrorColor={BaSeTheme.colors.feedbackInterface.erro45}
              activeColor={BaSeTheme.colors.feedbackInterface.sucesso}
              completedColor={BaSeTheme.colors.feedbackInterface.sucesso70}
              orientation={'horizontal'}
            />
          </StepWrapper>
          <ResultBoxMessageWrapper isSuccess={true}>
            <BaSeIcon
              color={BaSeTheme.colors.defaultColors.white}
              description={'Success'}
              name={getIcon(true)}
              size={32}
            />
            <ResultTextMessagetWrapper>
              <ResultTextTitle>
                <BaSeParagraph
                  isBold
                  color={BaSeTheme.colors.defaultColors.white}
                >
                  Seu questionário foi enviado com sucesso!
                </BaSeParagraph>
              </ResultTextTitle>
              <ResultTextSubTitle>
                <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
                  Muito obrigado por compartilhar sua opinião sobre mim.
                </BaSeParagraph>
              </ResultTextSubTitle>
            </ResultTextMessagetWrapper>
          </ResultBoxMessageWrapper>

          <ImageWrapper>
            <ImageResult isSuccess={true} />
          </ImageWrapper>
        </ResultWrapper>
      </Container>
    </React.Fragment>
  );
};

function getIcon(success) {
  return success ? 'clock-three' : 'exclamation-octagon';
}
